import { includes } from 'lodash';
import { PHONE_TYPES_THAT_CAN_RECEIVE_WRITTEN_COMMUNICATION } from '../PhoneTypeField/constants';
export default function phoneCanReceiveWrittenCommunication() {
  var phoneType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var phoneTypeEmpty = phoneType === '';
  return phoneTypeEmpty || includes(PHONE_TYPES_THAT_CAN_RECEIVE_WRITTEN_COMMUNICATION, phoneType);
}
//# sourceMappingURL=phoneCanReceiveWrittenCommunication.js.map